import {
  InvestmentProductConfigurationModelSection,
  InvestmentProductModelsDTO,
} from "@models/product/investment-product/entities/model";
import { PortfolioCalculatedReturnsDTO } from "@models/product/investment-product/entities/investmentProduct";
import { cloneDeep, isEmpty, set } from "lodash";
import { format, lastDayOfMonth } from "date-fns";
import { DateFormat } from "@constants/format";

export const getRecalculatedPerformanceModelData = ({
  originalData,
  selectedModelIndex,
  updatedData,
  date,
}: {
  originalData?: InvestmentProductModelsDTO[];
  updatedData: PortfolioCalculatedReturnsDTO;
  selectedModelIndex: [number, number];
  date: Date;
}): InvestmentProductModelsDTO[] | undefined => {
  const clonedData = cloneDeep(originalData);
  if (!clonedData) return;

  const dateToUpdate = format(lastDayOfMonth(date), DateFormat);
  const targetModel =
    clonedData?.[selectedModelIndex[0]].models?.[selectedModelIndex[1]];
  const sectionStaticIdRecord = buildSectionStaticIdRecord(
    targetModel?.sections || [],
  );

  targetModel?.sections?.forEach((targetSection) => {
    const targetSectionStaticId = targetSection.staticId;
    if (!targetSectionStaticId) return;

    const sectionStaticRecord = sectionStaticIdRecord[targetSectionStaticId];
    if (!sectionStaticRecord) return;

    targetSection.nameExtension = dateToUpdate;

    const targetFeatures = targetSection.features;
    targetFeatures?.forEach((targetFeature) => {
      const targetFeatureStaticId = targetFeature.staticId;
      if (!targetFeatureStaticId) return;

      const isFeatureStaticIdInSection = sectionStaticRecord.includes(
        targetFeatureStaticId,
      );

      if (!isFeatureStaticIdInSection) return;

      const updatedDataToChange = updatedData?.sections
        ?.find((s) => s.staticId === targetSectionStaticId)
        ?.features?.find((f) => f.staticId === targetFeatureStaticId)?.value;
      if (isEmpty(updatedDataToChange) || !updatedDataToChange) return;

      targetFeature.productData = {
        ...targetFeature.productData,
        value: updatedDataToChange,
      };
    });
  });

  set(
    clonedData,
    `${selectedModelIndex[0]}.models.${selectedModelIndex[1]}`,
    targetModel,
  );

  return clonedData;
};

const buildSectionStaticIdRecord = (
  sections: InvestmentProductConfigurationModelSection[],
): Record<string, string[]> => {
  const sectionStaticIdRecord: Record<string, string[]> = {};
  sections?.forEach((section) => {
    if (!section.staticId) return;

    sectionStaticIdRecord[section.staticId] =
      section.features
        ?.filter((feature) => feature.staticId)
        ?.map((feature) => feature.staticId as string) || [];
  });
  return sectionStaticIdRecord;
};
